export { default as ShipmentInfoReturnList } from './ShipmentInfoReturnList';
export { default as ShipmentInfoReturnDetailList } from './ShipmentInfoReturnDetailList';



// WEBPACK FOOTER //
// ./src/modules/shipment-info-return/pages/index.js